__turbopack_context__.v({
  "button-card": "SimulationTypeToggle-module-scss-module__Q3AmaW__button-card",
  "reset-button": "SimulationTypeToggle-module-scss-module__Q3AmaW__reset-button",
});
